var exports = {
  "M": "x804f0401--c5d85b--tab",
  "v": "x804f0401--c5d85b--active",
};

module.exports = exports;
